export const resolveSupportingPanelMaxSize = (args: {
  direction: "vertical" | "horizontal";
  width: number | undefined;
  height: number | undefined;
  maxWidth: number | undefined;
  maxHeight: number | undefined;
}) => {
  if (args.direction === "vertical") {
    if (args.height === undefined || args?.maxHeight === undefined) {
      return undefined;
    }

    if (args?.maxHeight > args.height) {
      return undefined;
    }

    return (args?.maxHeight / args.height) * 100;
  } else {
    if (args.width === undefined || args?.maxWidth === undefined) {
      return undefined;
    }

    if (args?.maxWidth > args.width) {
      return undefined;
    }

    return (args?.maxWidth / args.width) * 100;
  }
};
